import * as React from "react";

import { DropdownContext } from "./DropdownProvider";

export const DropdownMenuNoResults = (props: React.PropsWithChildren<any>) => {
    const { children } = props;
    const { classes } = React.useContext(DropdownContext);

    return (
        <p className={classes?.emptyResults}>{children || "No Results Found"}</p>
    );
};
